import { render } from "./MonitorStudentDetail.vue?vue&type=template&id=038bbcf0&scoped=true"
import script from "./MonitorStudentDetail.vue?vue&type=script&lang=js"
export * from "./MonitorStudentDetail.vue?vue&type=script&lang=js"

import "./MonitorStudentDetail.vue?vue&type=style&index=0&id=038bbcf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038bbcf0"]])

export default __exports__